export const ConfigTableconstant ={

    CONFIG_TABLE_SAGA: "CONFIG_TABLE_SAGA",
    CONFIG_TABLE_REQUEST: "CONFIG_TABLE_REQUEST",
    CONFIG_TABLE_RESPONSE: "CONFIG_TABLE_RESPONSE",
    CONFIG_TABLE_API: "/configuration",



    CONFIG_UPDATE_CANCEL_SAGA: "CONFIG_UPDATE_CANCEL_SAGA",
    CONFIG_UPDATE_CANCEL_REQUEST: "CONFIG_UPDATE_CANCEL_REQUEST",
    CONFIG_UPDATE_CANCEL_RESPONSE: "CONFIG_UPDATE_CANCEL_RESPONSE",
    CONFIG_UPDATE_CANCEL_API: "/configuration",

}